import request from '@/utils/request'

export function login (username, password) {
  return request({
    url: '/api/seller/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function logout () {
  return request({
    url: '/api/seller/logout',
    method: 'post'
  })
}

export function getSellerInfo () {
  return request({
    url: '/api/seller/seller_info',
    method: 'post'
  })
}

export function resetSellerPwd (payload) {
  return request({
    url: '/api/seller/modify_pwd',
    method: 'post',
    data: payload
  })
}
export function forgetSellpwd (payload) {
  return request({
    url: '/api/seller/forget_pwd',
    method: 'post',
    data: payload
  })
}
export function sendCode (payload) {
  return request({
    url: '/api/seller/send_code',
    method: 'post',
    data: payload
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js